import { render, staticRenderFns } from "./project_settings.vue?vue&type=template&id=7442cf54&scoped=true&"
import script from "./project_settings.vue?vue&type=script&lang=ts&"
export * from "./project_settings.vue?vue&type=script&lang=ts&"
import style0 from "./project_settings.vue?vue&type=style&index=0&id=7442cf54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7442cf54",
  null
  
)

export default component.exports